module.exports = __webpack_public_path__ + "img/water3-3.2e383efd.jpg";